// Image paths
export const IMAGE_PATHS = {
  // User avatars
  JASON_AVATAR: "/images/jason.png",
  MAYA_AVATAR: "/images/maya.png",
  KOA_AVATAR: "/images/koa.png",
  SARAH_AVATAR: "/images/sarah.png",
  OLLIE_AVATAR: '/images/ollie.png',
  DEFAULT_AVATAR: '/images/default-avatar.png',
  
  // Logos and icons
  LIFETRACK_COIN: '/images/lifetrack-coin.png',
  FALLBACK: '/images/fallback.jpg',
  
  // Videos
  MAYA_VIDEO: "https://asset.cloudinary.com/dzg3lv6fh/fa9207c8c810793f15599c9d13c4201e",
  DEFAULT_VIDEO: '/images/corporategirl.mp4'
} as const;